import type { TenantConfig } from '../types';

export const defaultTenant: TenantConfig = {
  id: 'default',
  branding: {
    name: 'Client Management ',
    favicon: process.env.REACT_APP_FAVICON || '/favicon.ico',
    pageTitle: process.env.REACT_APP_PAGE_TITLE || 'Customer Support Portal',
    metaDescription: process.env.REACT_APP_META_DESCRIPTION || 'Customer Support Portal',
    metaAuthor: process.env.REACT_APP_META_AUTHOR || 'Multigenesys. All rights reserved.',
    fontsUrl: process.env.REACT_APP_GOOGLE_FONTS_URL,
  },
  theme: {
    primary: 'var(--color-primary)',
    primaryHover: 'var(--color-primary-hover)',
    primaryLight: 'var(--color-primary-light)',
    secondary: 'var(--color-secondary)',
    accent: 'var(--color-primary)',
    sidebarBg: 'var(--color-white)',
    sidebarText: 'var(--color-gray-600)',
    sidebarActiveText: 'var(--color-primary)',
    sidebarActiveBg: 'var(--color-primary-light)',
  },
};
